import { type PropsWithChildren } from 'react';

import { ErrorPage } from '@/components/ErrorPage';
import { LoaderFull } from '@/components/LoaderFull';
import {
  useCandidateSearchParams,
  useGetCandidateQuery,
} from '@/features/interview';
import { InterviewScheduleStatus } from '@/services/api';

import { InterviewCompletedPage } from '../interview/InterviewCompletedPage';
import { InterviewExpiredPage } from '../interview/InterviewExpiredPage';
import { InterviewNotStartedPage } from '../interview/InterviewNotStartedPage';

export const GuardInterview: React.FC<PropsWithChildren> = ({ children }) => {
  const { candidateId, token } = useCandidateSearchParams();

  const candidate = useGetCandidateQuery(
    {
      candidateId: candidateId!,
      token: token!,
    },
    {
      enabled: !!candidateId && !!token,
    }
  );

  if (
    candidate.data?.completedAt &&
    !candidate.data.interview?.interviewSettings?.isSuggestionEnabled
  ) {
    return <InterviewCompletedPage />;
  }

  if (
    candidate.data?.interview?.scheduleStatus ===
      InterviewScheduleStatus.Expired ||
    candidate.error?.response?.status === 401
  ) {
    return <InterviewExpiredPage />;
  }

  if (
    candidate.data?.interview?.scheduleStatus ===
    InterviewScheduleStatus.NotStarted
  ) {
    return (
      <InterviewNotStartedPage
        targetTime={candidate.data?.interview?.startDate as string}
      />
    );
  }

  if (!candidateId || !token || candidate.isError) {
    return <ErrorPage errorCode={candidate.error?.response?.status} />;
  }

  if (candidate.data) return children;

  return <LoaderFull />;
};
